import React from 'react';
import { useTranslation } from 'react-i18next';
import { LanguageMenu } from '@easydent/shared-ui';
import { setLang } from '@/i18n';

/** Romania-first, English available. */
const LANGUAGES = [
  { code: 'ro', label: 'Română' },
  { code: 'en', label: 'English' },
];

/**
 * Language switch for the public site.
 *
 * <p>
 * Uses the same {@link LanguageMenu} as every other app rather than the segmented RO|EN pill this
 * used to be. The pill was the odd one out — a two-button toggle sitting beside a dropdown theme
 * control, in a product where language is a dropdown everywhere else. It also could not grow: a
 * third language would have made it three buttons wide in a corner that is already crowded.
 * </p>
 *
 * <p>
 * Placement belongs to the caller — it shares the top-right corner with the theme switch.
 * </p>
 */
const LanguageToggle: React.FC = () => {
  const { t, i18n } = useTranslation();
  return (
    <LanguageMenu
      value={i18n.language}
      languages={LANGUAGES}
      // LanguageMenu speaks in plain strings; setLang takes the union. Narrow rather than
      // cast, so an unknown code falls back to Romanian instead of being forced through.
      onChange={(code) => setLang(code === 'en' ? 'en' : 'ro')}
      aria-label={t('common.language', 'Language')}
    />
  );
};

export default LanguageToggle;
